import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Utils from "../../utils/Utils";

const BASE_URL = "https://iacdc.tau.ac.il/api/list";

const FolderBrowser = () => {
    const location = useLocation();
    const relativePath = location.pathname.replace(/^\/data\/?/, '').replace(/\/+$/, '');
    const fullUrl = `${BASE_URL}/${relativePath}`.replace(/\/+$/, '') + '/';
    const [entries, setEntries] = useState([]);
    const mainDir = relativePath.split('/', 1).toString()
    const dataset = mainDir.replace(/_/g, ' ')
    // Split path into parts (for breadcrumbs)
    const pathParts = relativePath ? relativePath.split('/').filter(Boolean) : [];
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    useEffect(() => {
        console.log("relative path", relativePath, typeof relativePath)
        console.log("main dir", mainDir)
        console.log("full path", fullUrl)
        console.log("dataset ", dataset)
        console.log("pathParts", pathParts)
        let datas = async () => {
            let resp = await Utils.getSubDirs(relativePath)
            let response = resp.data.items
            setItems(response || []);
            setPagination(resp.data.pagination || null);


            const data = [];

            // eslint-disable-next-line array-callback-return
            response.forEach(line => {
                const name = line["name"]
                const type = line["type"]
                const sizeStr = line["size_mb"]
                const path = line["path"]
                const isDirectory = type === "dir";
                const sizeMB = sizeStr || "";

                if (type !== 'sh' && type !== 'py' && type !== "mat" && type !== "m" && type !== "txt") {
                    data.push({
                        name: name,
                        directory: isDirectory,
                        size: sizeMB,
                        type: type,
                        href: path
                    });
                }
            })
            setEntries(data.filter(d => d.name !== undefined));
        }
        datas()
        setPage(1);
    }, [relativePath, page, pageSize]);

    const toggleFileSelection = (path) => {
        setSelectedFiles((prev) =>
                prev.includes(path)
                    ? prev.filter((p) => p !== path)
                    : [...prev, path]
        );
    };


    const downloadSelectedZip = async () => {
        try {
            const response = await Utils.multiDownloads({paths: selectedFiles,})
            const blob = response.data;
            if (!(blob instanceof Blob)) {
                alert("Response is not a file");
                return;
            }
            if (blob.size === 0) {
                alert("ZIP file is empty");
                return;
            }
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a")
            link.href = downloadUrl;
            link.download = "selected_files.zip";
            link.target = "_self";
            //link.setAttribute("download", "selected_files.zip");
            //link.style.display = "none";
            document.body.appendChild(link);
            // important
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                }, 2000);
        } catch (error) {
            console.error("ZIP download failed:", error);
            let message = "ZIP download failed";
            if (error.response?.data instanceof Blob) {
                const text = await error.response.data.text();
                try {
                    const json = JSON.parse(text);
                    message = json.error || json.message || message;
                } catch {
                    message = text || message;
                }
            } else if (error.response?.data?.error) {
                message = error.response.data.error;
            } else if (error.message) {
                message = error.message;
            }
            alert(message);
        }
    }
    return (
        <div>
            <div className={"flex-child-element:first-child"} align={"left"}
                     style={{float: "right", width: "27%", marginTop: "60px", marginRight: "35px"}}>
                <h3 style={{marginBottom: "40px"}}>{dataset || '/'}</h3>
            </div>
            <div className={"flex-child-element"}
                 style={{marginLeft: "25px", marginTop: "75px", marginBottom: "30px", width: "55%"}}>
                <div align={"left"}>
                    <h2>{dataset || '/'}</h2>
                    <br/>
                    {/* Breadcrumbs */}
                    {pathParts.length > 0 && (
                        <nav style={{ marginBottom: 10 }}>
                            {pathParts.map((part, idx) => {
                                const subPath = pathParts.slice(0, idx + 1).join('/');
                                console.log("subpath: ", subPath);
                                return (
                                    <span key={idx} style={{backgroundColor: "lightgray"}}>
                                        {' / '}
                                        <Link to={`/data/${subPath}`}>{part}</Link>
                                    </span>
                                );
                            })}
                        </nav>
                    )}
                    <div style={{ marginBottom: "10px" }}>
                        <span
                            onClick={() => {
                                if (selectedFiles.length === 0) {
                                    alert("No files selected");
                                    return;
                                }
                                downloadSelectedZip();
                            }}
                            style={{
                                color: selectedFiles.length ? "blue" : "gray",
                                textDecoration: "underline",
                                cursor: selectedFiles.length ? "pointer" : "not-allowed",
                            }}
                        >
                            Download selected as ZIP
                        </span>
                    </div>
                    {pagination && (
                        <div style={{ marginBottom: "10px" }}>
                            <label>
                                Rows per page:
                                <select
                                    name={"pagination"}
                                    value={pageSize}
                                    onChange={(e) => {
                                        setPageSize(Number(e.target.value));
                                        setPage(1);
                                    }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </label>

                            <span style={{ marginLeft: "20px" }}>
                                Page {pagination.page} of {pagination.total_pages}
                            </span>

                            <span style={{ marginLeft: "20px" }}>
                                Total items: {pagination.total}
                            </span>

                            <span
                                onClick={() => {
                                    if (pagination.has_prev) {
                                        setPage((p) => p - 1);
                                    }
                                }}
                                style={{
                                    marginLeft: "15px",
                                    color: pagination.has_prev ? "blue" : "gray",
                                    cursor: pagination.has_prev ? "pointer" : "not-allowed",
                                    textDecoration: "underline",
                                }}
                            >
                                Previous
                            </span>

                            <span
                                onClick={() => {
                                    if (pagination.has_next) {
                                        setPage((p) => p + 1);
                                    }
                                }}
                                style={{
                                    marginLeft: "15px",
                                    color: pagination.has_next ? "blue" : "gray",
                                    cursor: pagination.has_next ? "pointer" : "not-allowed",
                                    textDecoration: "underline",
                                }}
                            >
                                Next
                            </span>

                            <span style={{ marginLeft: "20px" }}>
                                Selected files: {selectedFiles.length}
                            </span>
                        </div>
                    )}
                    {/* Table */}
                    <table cellPadding="6" style={{ borderCollapse: "collapse", width: "90%" }}>
                        <thead>
                        <tr style={{ border: "1px solid black" }}>
                            <th>Select</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Size (MB)</th>
                            <th>Download directory</th>
                        </tr>
                        </thead>
                        <tbody>
                        {/* WGET ROW FOR CURRENT DIRECTORY */}
                        {relativePath && (
                            <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <td></td>
                                <td>
                                    <a
                                        href={`/api/download-directory-wget?path=${encodeURIComponent(relativePath)}`}
                                        style={{
                                            color: "green",
                                            fontWeight: "bold",
                                            textDecoration: "underline",
                                        }}
                                    >
                                        ⬇ Download this directory with wget
                                    </a>
                                </td>
                                <td>wget</td>
                                <td>-</td>
                                <td>-</td>
                            </tr>
                        )}
                        {entries.map((entry, i) =>
                            entry.type !== "py" && entry.type !== "sh" ? (
                                <tr key={entry.href || i}>
                                    <td>
                                        {!entry.directory && (
                                            <input
                                                type="checkbox"
                                                checked={selectedFiles.includes(entry.href)}
                                                onChange={() => toggleFileSelection(entry.href)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {entry.directory ? (
                                            <Link to={`/data/${entry.href}`}>
                                                📁 {entry.name}
                                            </Link>
                                        ) : (
                                            <a
                                                href={`/api/download/file/${entry.href}`}
                                                style={{
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                📄 {entry.name}
                                            </a>
                                        )}
                                    </td>
                                    <td>{entry.directory ? "dir" : entry.type}</td>
                                    <td>{entry.directory ? "-" : entry.size}</td>
                                    <td>
                                        {entry.directory ? (
                                            <a
                                                href={`/api/download-directory-wget?path=${encodeURIComponent(entry.href)}`}
                                                style={{
                                                    color: "blue",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                wget
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                            ) : null
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default FolderBrowser;

/*

const AutoindexBrowser = ({ baseUrl = "https://iacdc.tau.ac.il/files/" }) => {
    const pathname = window.location.pathname.slice(1)
    const mainDir = pathname.split("/", 1)
  const [currentUrl, setCurrentUrl] = useState(`${baseUrl}${mainDir}`);
  const [items, setItems] = useState([]);
  const [history, setHistory] = useState([baseUrl]);
  const [selected, setSelected] = useState([]);

  // --- Fetch directory listing ---
  useEffect(() => {
    fetch(currentUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const links = [...doc.querySelectorAll('pre a')]
          .filter(link => link.getAttribute('href') !== '../')
          .map(link => {
            const href = link.getAttribute('href');
            return {
              name: href,
              isDirectory: href.endsWith('/'),
              url: new URL(href, currentUrl).href
            };
          });
        setItems(links);
      });
  }, [currentUrl]);

  const handleClick = (item) => {
    if (item.isDirectory) {
      setHistory(prev => [...prev, item.url]);
      setCurrentUrl(item.url);
    }
  };

  const goBack = () => {
    if (history.length > 1) {
      const newHistory = [...history];
      newHistory.pop();
      setHistory(newHistory);
      setCurrentUrl(newHistory[newHistory.length - 1]);
    }
  };

  const toggleSelect = (url) => {
    setSelected(prev =>
      prev.includes(url) ? prev.filter(u => u !== url) : [...prev, url]
    );
  };

  const handleDownload = async () => {
    const response = await fetch('/api/zip', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ urls: selected }),
    });
    const blob = await response.blob();
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'selection.zip');
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(href);
  };

  const renderBreadcrumbs = () => {
    return history.map((url, i) => {
      const path = new URL(url).pathname.replace(/\/+$/, '');
      const label = path.split('/').pop() || '/';
      return (
        <span key={i}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setCurrentUrl(url);
              setHistory(history.slice(0, i + 1));
            }}
          >
            {label || 'Root'}
          </a>
          {i < history.length - 1 && ' / '}
        </span>
      );
    });
  };

  return (
    <div>
      <h2>📁 {renderBreadcrumbs()}</h2>
      {history.length > 1 && <button onClick={goBack}>⬅ Go Up</button>}

      <ul>
        {items.map((item, i) => (
          <li key={i}>
            <input
              type="checkbox"
              checked={selected.includes(item.url)}
              onChange={() => toggleSelect(item.url)}
            />
            {' '}
            {item.isDirectory ? '📂' : '📄'}{' '}
            <a
              href={item.isDirectory ? '#' : item.url}
              onClick={(e) => {
                if (item.isDirectory) {
                    console.log(item);
                  e.preventDefault();
                  handleClick(item);
                }
              }}
              target={item.isDirectory ? '' : '_blank'}
              rel="noreferrer"
            >
              {item.name}
            </a>{' '}
            {!item.isDirectory && (
              <code>wget {item.url}</code>
            )}
          </li>
        ))}
      </ul>

      {selected.length > 0 && (
        <div>
          <p>{selected.length} item(s) selected</p>
          <button onClick={handleDownload}>📦 Download ZIP</button>
        </div>
      )}
    </div>
  );
};

export default AutoindexBrowser;*/